import React from "react";
import classNames from "classnames";

export type FormLabelProps = React.LabelHTMLAttributes<HTMLLabelElement> & {
  hasError?: boolean;
};

const FormLabel: React.FC<FormLabelProps> = ({
  children,
  className,
  hasError,
  ...props
}) => {
  return (
    <label
      className={classNames(
        "block text-sm",
        !hasError && "font-bold",
        className,
      )}
      {...props}
    >
      {children}
    </label>
  );
};

export default FormLabel;
